var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFieldIconWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 8.19902C11.5 11.6984 9.09375 13.4481 6.23375 14.463C6.08399 14.5146 5.92131 14.5122 5.77313 14.456C2.90625 13.4481 0.5 11.6984 0.5 8.19902V3.29985C0.5 3.11423 0.572433 2.93621 0.701364 2.80495C0.830295 2.6737 1.00516 2.59996 1.1875 2.59996C2.5625 2.59996 4.28125 1.7601 5.4775 0.696282C5.62315 0.569602 5.80843 0.5 6 0.5C6.19157 0.5 6.37685 0.569602 6.5225 0.696282C7.72563 1.7671 9.4375 2.59996 10.8125 2.59996C10.9948 2.59996 11.1697 2.6737 11.2986 2.80495C11.4276 2.93621 11.5 3.11423 11.5 3.29985V8.19902Z",
    stroke: "#C5C5C5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFieldIconWeb);
export default __webpack_public_path__ + "static/media/field-icon-web.4a7b1cd0dd8590200e4a38c94e34e6e4.svg";
export { ForwardRef as ReactComponent };